// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_9ws","icon":"styles_icon__2LJFj"};